import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import classnames from 'classnames';
import { Component } from '@wordpress/element';
import Gridicon from 'gridicons';
import PropTypes from 'prop-types';
/**
 * Use `Rating` to display a set of stars, filled, empty or half-filled, that represents a
 * rating in a scale between 0 and the prop `totalStars` (default 5).
 */

var Rating =
/*#__PURE__*/
function (_Component) {
  _inherits(Rating, _Component);

  function Rating() {
    _classCallCheck(this, Rating);

    return _possibleConstructorReturn(this, _getPrototypeOf(Rating).apply(this, arguments));
  }

  _createClass(Rating, [{
    key: "stars",
    value: function stars() {
      var _this$props = this.props,
          size = _this$props.size,
          totalStars = _this$props.totalStars;
      var starStyles = {
        width: size + 'px',
        height: size + 'px'
      };
      var stars = [];

      for (var i = 0; i < totalStars; i++) {
        stars.push(createElement(Gridicon, {
          key: 'star-' + i,
          icon: "star",
          style: starStyles
        }));
      }

      return stars;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          rating = _this$props2.rating,
          totalStars = _this$props2.totalStars,
          className = _this$props2.className;
      var classes = classnames('woocommerce-rating', className);
      var perStar = 100 / totalStars;
      var outlineStyles = {
        width: Math.round(perStar * rating) + '%'
      };
      var label = sprintf(__('%1$s out of %2$s stars.', 'woocommerce-admin'), rating, totalStars);
      return createElement("div", {
        className: classes,
        "aria-label": label
      }, this.stars(), createElement("div", {
        className: "woocommerce-rating__star-outline",
        style: outlineStyles
      }, this.stars()));
    }
  }]);

  return Rating;
}(Component);

Rating.propTypes = {
  /**
   * Number of stars that should be filled. You can pass a partial number of stars like `2.5`.
   */
  rating: PropTypes.number,

  /**
   * The total number of stars the rating is out of.
   */
  totalStars: PropTypes.number,

  /**
   * The size in pixels the stars should be rendered at.
   */
  size: PropTypes.number,

  /**
   * Additional CSS classes.
   */
  className: PropTypes.string
};
Rating.defaultProps = {
  rating: 0,
  totalStars: 5,
  size: 18
};
export default Rating;
//# sourceMappingURL=index.js.map